import { Alert } from '@mui/material';
import { FC } from 'react';
import { Trans } from 'react-i18next';
import { StatusCodesList } from '@/api';

const errorMessages = {
  [StatusCodesList.NotFound]: 'auth.error.invalid_credentials',
  [StatusCodesList.InvalidCredentials]: 'auth.error.invalid_credentials',
  [StatusCodesList.AccountAlreadyExists]: 'auth.error.already_exists',
  [StatusCodesList.AccountNotActivated]: 'auth.error.not_activated',
  [StatusCodesList.AccountNotApproved]: 'auth.error.not_approved',
};

export const AuthMessage: FC<{ error?: number }> = ({ error }) => (
  <div className="pb-6">
    <Alert severity="error">
      <Trans i18nKey={errorMessages[error as keyof typeof errorMessages]} />
    </Alert>
  </div>
);
